/* eslint-disable no-undef */
export const Config = {
  devMode: import.meta.env.VITE_BACKEND_BASE || true,
  cookieDomain: import.meta.env.VITE_COOKIE_DOMAIN || "localhost",
  backendBase: import.meta.env.VITE_BACKEND_BASE || "http://localhost:9000",
  frontendBase: import.meta.env.VITE_FRONTEND_BASE || "http://localhost:3000",
  termsOfServiceUrl: "https://pattern-web-assets.s3.amazonaws.com/tos_20200518.pdf",
  launchDarkly: import.meta.env.VITE_LAUNCHDARKLY || "6144f11cd46487264103cc17",
  anonymousKey: import.meta.env.VITE_LD_ANONYMOUS_KEY || "local-anon",
  firmIntakeTemplateUrl: "https://pattern-web-assets.s3.amazonaws.com/Firm_Template.xlsx",
  caseIntakeInstructionsUrl:
    "https://support.patterndata.io/hc/en-us/articles/1500000953862-How-do-I-create-a-new-case-#h_01F4WJ4ZX77AWCVTAKJD09YCF8",
  segmentKey: import.meta.env.VITE_SEGMENT_KEY || "bRwH5fFuKSBzcoIDjms8urGReNzOijCE",
  pubnubSubscribeKey: import.meta.env.VITE_PUBNUB_SUBSCRIBE_KEY || "sub-c-5ed6ea46-b48f-11ea-afa6-debb908608d9",
  helpCenterUrl: "https://support.patterndata.io/hc/en-us",
  submitHelpRequestUrl: "https://support.patterndata.io/hc/en-us/requests/new",
  lookerOrigin: import.meta.env.VITE_LOOKER_ORIGIN || "",
  lookerEmbedDomain: import.meta.env.VITE_LOOKER_EMBED_DOMAIN || "",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  sentrySampleRate: import.meta.env.VITE_SENTRY_SAMPLE,
  serverConnectionInterval: import.meta.env.VITE_SERVER_CONNECTION_INTERVAL || `${30 * 1000}`,
  version: "220",
};
